<div class="filter-placeholder filter-placeholder-list" *ngIf="isLoading">
  <div class="list-item-placeholder"></div>
  <div class="list-item-placeholder"></div>
  <div class="list-item-placeholder"></div>
  <div class="list-item-placeholder"></div>
</div>

<div class="dropdown-container" *ngIf="!isLoading" (capraClickOutside)="closeDropdown()">
  <button
    *ngIf="isMulti"
    #multiMenuTrigger="matMenuTrigger"
    class="dropdown-button"
    [class.open]="isOpen"
    (menuOpened)="isOpen = true"
    (menuClosed)="isOpen = false"
    [matMenuTriggerFor]="multiSelectFilter"
    data-test="multiselect-menu-filter-trigger"
    capraTooltip
    [tooltipContent]="dropdownLabel"
    tooltipSize="mini"
    tooltipPlacement="left"
  >
    <div>{{ dropdownLabel }}</div>
    <capra-icon icon="icon-caret-down"></capra-icon>
  </button>

  <mat-menu #multiSelectFilter class="dropdown-mat-menu" [hasBackdrop]="false">
    <div (click)="$event.stopPropagation()">
      <mode-multi-select
        [showAll]="showAll"
        [filter]="filter"
        [filterOption]="filterOption"
        [isLoading]="isLoading"
        [isOpen]="isOpen"
        (filterChange)="onMultiSelectChange($event.filter, $event.selectedValue, $event.isChecked, $event.searchTerm)"
      ></mode-multi-select>
    </div>
  </mat-menu>

  <button
    *ngIf="isSingle"
    #singleMenuTrigger="matMenuTrigger"
    class="dropdown-button"
    [class.open]="isOpen"
    (menuOpened)="isOpen = true"
    (menuClosed)="isOpen = false"
    [matMenuTriggerFor]="singleSelectFilter"
    data-test="single-select-menu-filter-trigger"
    capraTooltip
    [tooltipContent]="dropdownLabel"
    tooltipSize="mini"
    tooltipPlacement="left"
  >
    <div>{{ dropdownLabel }}</div>
    <capra-icon icon="icon-caret-down"></capra-icon>
  </button>

  <mat-menu #singleSelectFilter class="dropdown-mat-menu" [hasBackdrop]="false">
    <div (click)="$event.stopPropagation()">
      <mode-single-select
        [showAll]="showAll"
        [filter]="filter"
        [filterOption]="filterOption"
        [isLoading]="isLoading"
        [isOpen]="isOpen"
        (filterChange)="onSingleSelectChange($event)"
      ></mode-single-select>
    </div>
  </mat-menu>
</div>
